import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import type { ObjectTypeFilter } from './types.ts'

/**
 * Загружает типы объектов и доступные варианты фильтрации.
 */
export const useLoadInventFilterDataV3 = (objectId: Ref<number>) => {
  const http = useHttp()

  return useQuery({
    queryKey: computed(() => ['load_invent_filter_data_v3', objectId.value]),
    queryFn: async () => {
      const response = await http.get(`/inventory/objects/${objectId.value}/filter-types-v3`)
      if (!Array.isArray(response.data)) {
        throw new Error('Invalid filter types response')
      }
      return response.data as ObjectTypeFilter[]
    },
    enabled: computed(() => Number.isFinite(objectId.value) && objectId.value > 0),
    retry: 2,
  })
}
